/**
 * Automatically populates the table of contents. See _toc.phtml for more details.
 */
export default function () {
    $(() => {
        const $tocContainer = $('#toc');
        const $chaptersContainer = $('#chapters', $tocContainer);
        let chapterCount = 1;

        /**
         * @param chapterElement
         * @param pageNr
         */
        function addChapter(chapterElement: HTMLElement, pageNr: string): void {
            const hasId = chapterElement.hasAttribute('id');
            const hasAutoNumbering = $(chapterElement).hasClass('auto-numbering');

            let chapterLevel = 1;
            for (let j = 1; j <= 6; j++) {
                if ($(chapterElement).hasClass('chapter-l' + j)) {
                    chapterLevel = j;
                    break;
                }
            }

            if (!hasId) {
                $(chapterElement).attr('id', 'c' + chapterCount);
            }

            $chaptersContainer.append(
                $('<a/>')
                    .addClass('chapter-l' + chapterLevel)
                    .addClass(hasAutoNumbering ? 'auto-numbering' : '')
                    .attr('href', '#' + $(chapterElement).attr('id'))
                    .append(
                        $('<span/>')
                            .html($(chapterElement).text())
                    )
                    .append(
                        $('<span/>')
                            .addClass('page-nr')
                            .addClass('pdf-only')
                            .html(pageNr)
                    )
            );

            chapterCount++;
        }

        $('.toc-chapter').each(function () {
            const chapterElement = this;
            const pageNumber = $(chapterElement).data('toc-pdf-page');
            addChapter(chapterElement, pageNumber ?? '');
        });
    });
}